<template>
  <img :src="imgUrl" />
</template>

<script>
export default {
  components: {},

  props: {
    src: {
      type: String,
      default: "",
    },
  },
  computed: {
    imgUrl() {
      if (!this.src) {
        return (
          `${process.env.VUE_APP_BASE_URL ? "api" : ""}` +
          "/myrl".replace(/\\/gi, "/")
        );
      }
      return (
        `${process.env.VUE_APP_BASE_URL ? "api" : ""}` +
        "/myrl" +
        this.src.replace(/\\/gi, "/")
      );
    },
  },
  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped lang="scss"></style>
